import React, { FC } from 'react'

import { Flex } from '../../new/core-components/box'
import { SystemProps } from '../../new/theme'

type Props = {
  content?: React.ReactNode
} & SystemProps

export const EndContent: FC<Props> = ({ content, ...props }: Props) => {
  if (!content) {
    return null
  }

  return (
    <Flex alignItems='center' justifyContent='center' mr={6} {...props}>
      {content}
    </Flex>
  )
}
